import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import useMinAndStandardLabelQuery from "../../../../../../../api/estimate/useMinAndStandardLabelQuery"
import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import MinAndStandardLabelProvider from "../../../../components/1Click/MinAndStandardLabel/MinAndStandardLabelProvider"
import Radio from "../../../../components/1Click/MinAndStandardLabel/MinAndStandardLabelRadio"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidMinPattern from "../../../../service/visibleValidator/isValidMinPattern"

import img from "./minPattern.png"

const 最小パターン幅 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { minPattern: shouldShow } = getDisplayCondition(values)

  const { minId, standardId } = useMinAndStandardLabelQuery("minPattern", values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"最小パターン幅／\n間隔"}
      helpURL={HELP_LINKS["最小パターン幅／間隔"]}
      src={img}
    >
      <MinAndStandardLabelProvider minId={minId} standardId={standardId}>
        <RadioGroup
          name={FIELD_NAMES["最小パターン幅／間隔"]}
          selectedValue={values.minPattern}
          onChange={handlers.radio}
          shouldRender={(value) => isValidMinPattern(values, value)}
        >
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.030mm"].value}>0.030mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.050mm"].value}>0.050mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.060mm"].value}>0.060mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.075mm"].value}>0.075mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.10mm"].value}>0.10mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.127mm"].value}>0.127mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.15mm"].value}>0.15mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.20mm"].value}>0.20mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.25mm"].value}>0.25mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.30mm"].value}>0.30mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.35mm"].value}>0.35mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小パターン幅／間隔"]["0.40mm"].value}>0.40mm</Radio>
          </OneClickFieldStack>
        </RadioGroup>
      </MinAndStandardLabelProvider>
      <OneClickFieldMessages error={errors?.minPattern} />
    </OneClickField>
  )
}

export default 最小パターン幅
